require('a7e0d85450f323d5e164/focus-within.js');
require('focus-visible/dist/focus-visible.min.js');
require('waypoints/lib/noframework.waypoints.js');
import { Loader } from '@googlemaps/loader';
import enquire from 'enquire.js/dist/enquire.min';
import Flickity from 'flickity';

import { fez } from '@trepanation-pray/fez';

/*eslint-disable */
import { getCookie, setCookie } from '@trepanation-pray/cookie';
import {
  weasl,
  weaslOpen,
  weaslClose
} from '@trepanation-pray/weasl/src/weasl.js';
/*eslint-enable */

fez({ offset: 100 });

export default {
  init() {
    /*eslint-disable */

    function videoPlayer(videoElements) {

      var videos = document.body.querySelectorAll(videoElements);
      videos.forEach(function (video) {
        if (!video.classList.contains('is-enabled')) {
    
          var videoUi = document.createElement('div');
          videoUi.setAttribute('tabindex', '0');
          videoUi.classList.add('c-video-ui', 'c-video-ui--not-played', 'c-video-ui--paused');
    
          var videoFullscreen = document.createElement('button');
          videoFullscreen.setAttribute('type', 'button');
          videoFullscreen.classList.add('c-video-ui__fullscreen');
    
    
          var videoProgress = document.createElement('progress');
          videoProgress.setAttribute('min', '0');
          videoProgress.setAttribute('max', '100');
          videoProgress.setAttribute('value', '0');
    
          videoProgress.classList.add('c-video-ui__progress');
    
          video.before(videoUi);
          videoUi.append(video);
          videoUi.append(videoFullscreen);
          videoUi.append(videoProgress);
    
    
          videoUi.style.paddingTop = (video.videoHeight / video.videoWidth) * 100 + '%';
          // window.addEventListener('loadedmetadata', (event) => {
    
          // }, true);
    
    
          var videoControlTimout;
          /*eslint-disable */
          function StartVideoControlTimout() {
            videoControlTimout = setTimeout(function () {
              videoUi.classList.remove('c-video-ui--show-controls');
            }, 2000);
          }
          /*eslint-enable */
    
    
          videoUi.addEventListener('mousemove', function () {
            clearTimeout(videoControlTimout);
            videoUi.classList.add('c-video-ui--show-controls');
            StartVideoControlTimout();
          }, false);
    
          videoUi.addEventListener('mouseleave', function () {
            clearTimeout(videoControlTimout);
            videoUi.classList.remove('c-video-ui--show-controls');
            StartVideoControlTimout();
          }, false);
    
    
          video.addEventListener('timeupdate', function () {
            var percentage = Math.floor((100 / video.duration) * video.currentTime);
            videoProgress.value = percentage;
            videoProgress.innerHTML = percentage + '% played';
    
          }, false);
    
          videoProgress.addEventListener('click', function (event) {
            var percent = event.offsetX / this.offsetWidth;
            video.currentTime = percent * video.duration;
            videoProgress.value = percent / 100;
          }, false);
    
          video.addEventListener('seeked', function () {
    
            videoUi.classList.remove('c-video-ui--buffering');
    
    
          }, false);
    
          video.addEventListener('seeking', function () {
    
            videoUi.classList.add('c-video-ui--buffering');
    
          }, false);
    
          video.addEventListener('pause', function () {
    
            videoUi.classList.remove('c-video-ui--playing');
            videoUi.classList.add('c-video-ui--paused');
    
          }, false);
    
          video.addEventListener('play', function () {
    
            videoUi.classList.add('c-video-ui--playing');
            videoUi.classList.remove('c-video-ui--paused');
            videoUi.classList.remove('c-video-ui--not-played');
    
          }, false);
    
    
    
          videoUi.addEventListener('keydown', function (event) {
            if (event.currentTarget !== event.target) return;
            if (videoUi.classList.contains('c-video-ui--fullscreen')) {
              if (event.keyCode == 16 && event.keyCode == 9) {
                event.preventDefault();
                videoFullscreen.focus();
              } else if (event.keyCode == 9) {
                event.preventDefault();
                videoFullscreen.focus();
              }
    
            }
          });
    
          videoFullscreen.addEventListener('keydown', function (event) {
            if (event.currentTarget !== event.target) return;
            if (videoUi.classList.contains('c-video-ui--fullscreen')) {
              if (event.keyCode == 16 && event.keyCode == 9) {
                event.preventDefault();
                videoUi.focus();
              } else if (event.keyCode == 9) {
                event.preventDefault();
                videoUi.focus();
              }
    
            }
          });
    
    
          videoUi.addEventListener('keydown', function (event) {
            if (event.currentTarget !== event.target) return;
            if (event.keyCode == 13 || event.keyCode == 32) {
              if (video.paused) {
                video.play();
              } else {
                video.pause();
              }
            }
          });
    
          video.addEventListener('click', function (event) {
            if (event.currentTarget !== event.target) return;
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
    
          }, false);
    
          document.addEventListener('fullscreenchange', function () {
    
            if (!document.fullscreenElement) {
              videoUi.classList.remove('c-video-ui--fullscreen');
              document.body.classList.remove('video-fullscreen');
            }
    
          });
    
          videoFullscreen.addEventListener('click', function (event) {
            if (event.currentTarget !== event.target) return;
    
            videoUi.classList.toggle('c-video-ui--fullscreen');
    
            document.body.classList.toggle('video-fullscreen');
    
            if (document.fullscreenElement) {
              document.exitFullscreen();
            } else {
              document.documentElement.requestFullscreen();
            }
    
          }, false);
    
          video.classList.add('is-enabled');
        }
    
      });
    
    }
    
      // Video players
      videoPlayer('.c-video-ui__video');
    function googleAnalytics() {
      var AnalyticsScript = document.createElement('script');
      var AnalyticsId = 'GTM-KPMTRXXJ';
      AnalyticsScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', AnalyticsId);
      };
    
      AnalyticsScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + AnalyticsId;
    
      document.head.appendChild(AnalyticsScript);
    }
    
    
    
    if (getCookie('cookieControlTracking') && getCookie('cookieControlTracking') == 'accept') {
      googleAnalytics();
    
    }
    
    document.addEventListener('cookieAccept', () => {
      googleAnalytics();
    });
  /*eslint-enable */
    document.addEventListener('wpcf7mailsent', function (event) {

      setTimeout(function () {
        weasl({
          name: 'contact-thank-you',
          content: '<h2><span>Thank you</span></h2><p>' + event.detail.apiResponse.message + '</p>',
        });

      }, 500);

    }, false);

    // //hero cursor parrallax
    // var parallaxItems = document.querySelectorAll('.j-cursor-parallax');
    // var timeout;

    // window.addEventListener('mousemove', (event) => {

    //   parallaxItems.forEach(element => {

    //     let _w = window.innerWidth / 2;
    //     // let _h = window.innerHeight / 2;
    //     let _mouseX = event.clientX;
    //     // let _mouseY = event.clientY;
    //     // let _string = `${50 - (_mouseX - _w) * 0.02}% ${50 - (_mouseY - _h) * 0.04}%`;
    //     let _string = `${50 - (_mouseX - _w) * 0.02}% center`;

    //     // If there's a timer, cancel it
    //     if (timeout) {
    //       window.cancelAnimationFrame(timeout);
    //     }

    //     timeout = window.requestAnimationFrame(() => {
    //       element.style.backgroundPosition = _string;
    //     });




    //   })

    // });

    const loader = new Loader({
      apiKey: 'AIzaSyCmH7w3-5u9s2_2AEoRMcql3vo-1ta6wsM',
      version: 'weekly',
      libraries: ['places'],
    });

    const mapBlocks = document.body.querySelectorAll('.b-map');

    loader.loadCallback(e => {
      if (e) {
        console.log(e);
      } else {

        /*eslint-disable */

        mapBlocks.forEach(mapItem => {

          let mapElement = document.getElementById(mapItem.id);

          let location = JSON.parse(mapItem.dataset.location);

          let latLng = new google.maps.LatLng(location.lat, location.lng);

          let mapOptions = {
            center: latLng,
            zoom: location.zoom,
            disableDefaultUI: true,
          };

          let map = new google.maps.Map(mapElement, mapOptions);

          let icon = {
            path: 'M16.8,48.91C2.63,28.37,0,26.27,0,18.72C0,8.38,8.38,0,18.72,0s18.72,8.38,18.72,18.72 c0,7.55-2.63,9.66-16.8,30.19C19.71,50.25,17.73,50.25,16.8,48.91L16.8,48.91z M18.72,26.52c4.31,0,7.8-3.49,7.8-7.8 s-3.49-7.8-7.8-7.8s-7.8,3.49-7.8,7.8S14.41,26.52,18.72,26.52z',
            fillColor: '#E87722',
            fillOpacity: 1,
            scale: 1,
            strokeWeight: 0,
            size: new google.maps.Size(38, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(19, 50)
          };

          var infowindow = new google.maps.InfoWindow({
            content: '<div class="b-map__info"><h4 class="b-map__info-title">Address</h4><p class="b-map__info-text">' + location.address + '</p></div>',
          });

          let marker = new google.maps.Marker({
            map: mapElement,
            position: latLng,
            icon: icon,
          });

          marker.addListener('click', function () {
            infowindow.open(map, marker);
          });

          marker.setMap(map);
        });

        /*eslint-enable */

      }
    });




    // JavaScript to be fired on all pages

    var accordionContent = document.querySelectorAll('.js-accordion__content');

    window.addEventListener('load', function () {
      accordionContent.forEach(item => {
        item.style.display = 'block';
        item.setAttribute('data-height', item.getBoundingClientRect().height);
        item.style.maxHeight = '0';
        item.classList.add('is-loaded');
      });
    });
    
    var accordionButtons = document.querySelectorAll('.js-accordion__button');
    
    accordionButtons.forEach(button => {
      button.addEventListener('click', function () {
        var accordion = button.closest('.js-accordion'); // Find the accordion container
        var accordionItems = accordion.querySelectorAll('.js-accordion__content');
    
        var panel = button.parentElement.nextElementSibling;
    
        accordionItems.forEach(item => {
          if (item !== panel) {
            item.style.maxHeight = '0';
            item.classList.remove('is-active');
            var activeButton = item.parentElement.querySelector('.js-accordion__button');
            if (activeButton) {
              activeButton.classList.remove('is-active');
            }
          }
        });
    
        if (!panel.classList.contains('is-active')) {
          panel.style.maxHeight = panel.getAttribute('data-height') + 'px';
        } else {
          panel.style.maxHeight = '0';
        }
    
        button.classList.toggle('is-active');
        panel.classList.toggle('is-active');
      });
    });
    
    
    



    const chevron = 'M30.57,77.77l1.58-1.58c1.05-1.04,1.05-2.74,0.01-3.78c0,0,0,0-0.01-0.01L13.41,53.78h83.91c1.48,0,2.68-1.2,2.68-2.68c0,0,0,0,0-0.01v-2.23c0-1.48-1.2-2.68-2.68-2.68H13.41l18.74-18.62c1.05-1.04,1.05-2.74,0.01-3.78c0,0,0,0-0.01-0.01l-1.58-1.58c-1.04-1.05-2.74-1.05-3.78-0.01c0,0,0,0-0.01,0.01l-26,25.92c-1.05,1.04-1.05,2.74-0.01,3.78c0,0,0,0,0.01,0.01l26,25.87C27.83,78.82,29.52,78.82,30.57,77.77C30.57,77.78,30.57,77.77,30.57,77.77z';

    var imageBlocks = document.querySelectorAll('.b-image__list');

    if (imageBlocks) {
      window.addEventListener('load', function () {
        imageBlocks.forEach((list) => {
          /*eslint-disable */

          var imageSlider = new Flickity(list, {
            prevNextButtons: true,
            pageDots: true,
            autoPlay: 5000,
            wrapAround: true,
            arrowShape: chevron,
          });
          /*eslint-enable */
        });
      })
    }

    var sliderBLocks = document.querySelectorAll('.b-slider__list');
    if (sliderBLocks) {
      window.addEventListener('load', () => {
        sliderBLocks.forEach((list) => {
          console.log(list);
          /*eslint-disable */

          var slider = new Flickity(list, {
            prevNextButtons: true,
            pageDots: false,
            autoPlay: 5000,
            wrapAround: true,
            arrowShape: chevron,
          });
          /*eslint-enable */
        });
      })
    }


    document.body.addEventListener('click', function (event) {

      if (!event.target.matches('.o-site-footer__button')) return;
      event.preventDefault();
      var accordion = event.target.parentElement.nextElementSibling;
      if (accordion.classList.contains('active')) {
        accordion.style.height = '0';
      } else {
        accordion.style.height = accordion.getAttribute('data-height') + 'px';
      }
      accordion.classList.toggle('active');
    }, false);

    var footerAccordions = document.querySelectorAll('.o-site-footer__accordion');

    footerAccordions.forEach(item => {
      setTimeout(function () {
        item.setAttribute('data-height', item.offsetHeight)
        item.style.height = '0'
      }, 200)
    })

    //Video pop up

    var videosButton = document.body.querySelectorAll('.j-video-popup');
    videosButton.forEach(function (button) {
      button.addEventListener('click', (event) => {
        weasl({
          name: 'video-popup',
          width: '1150px',
          // content: event.target.nextElementSibling.outerHTML,
          content: event.target.dataset.url,
        });
      }, false);
    });

    // Waypoint trigger
    var waypointTriggers = document.body.querySelectorAll('.j-waypoint');

    waypointTriggers.forEach(function (trigger) {
      /*eslint-disable */
      var waypoint = new Waypoint({
        element: trigger,
        offset: '100%',
        handler: function () {
          setTimeout(() => this.element.classList.add('is-animate'), 250);
        },
      })
      /*eslint-enable */
    });


    // On window load events
    window.addEventListener('load', function () {

    });




    // Nav button

    document.body.addEventListener('click', function (event) {

      if (!event.target.matches('.o-mobile-navigation-button')) return;
      event.preventDefault();
      event.target.classList.toggle('active');
      document.body.querySelector('.o-primary-navigation').classList.toggle('active');
      document.body.classList.toggle('menu-active');

    }, false);

    // Top nav tabbable items

    const topNavList = document.body.querySelectorAll('.o-primary-navigation a, .o-primary-navigation button');

    // Mobile menu button tabbing for active and non-active state of menu

    document.body.addEventListener('keydown', function (event) {

      if (!event.target.matches('.o-mobile-navigation-button')) return;

      if (event.shiftKey && event.keyCode == 9) {

        if (event.target.classList.contains('active')) {
          event.preventDefault();
          topNavList[topNavList.length - 1].focus();

        } else {
          event.preventDefault();
          document.body.querySelector('.o-site-brand').focus();
        }

      } else if (event.keyCode == 9) {
        if (!event.target.classList.contains('active')) {
          event.preventDefault();
          document.body.querySelector('.o-main').focus();
        }
      }

    }, false);

    // Send tab focus from main content to menu button

    document.body.addEventListener('keydown', function (event) {

      if (!event.target.matches('.o-main')) return;

      if (event.shiftKey && event.keyCode == 9) {
        event.preventDefault();
        document.body.querySelector('.o-mobile-navigation-button').focus();
      }

    }, false);

    // Trap tabbing in menu


    topNavList[topNavList.length - 1].addEventListener('keydown', function (event) {

      if (event.shiftKey && event.keyCode == 9) {

        if (event.target.classList.contains('active')) {
          event.preventDefault();
          topNavList[topNavList.length - 2].focus();
        }
      } else if (event.keyCode == 9) {
        event.preventDefault();
        document.body.querySelector('.o-mobile-navigation-button').focus();
      }

    }, false);

    document.body.addEventListener('keydown', function (event) {

      if (!event.target.matches('.o-primary-navigation__show-sub-menu')) return;

      const submenuItems = event.target.nextElementSibling.querySelectorAll('.o-primary-navigation__link, .o-primary-navigation__show-sub-menu');



      if (event.keyCode == 13) {
        event.preventDefault();
        submenuItems[0].focus();
      }

    }, false);

    const menuItems = document.body.querySelectorAll('.o-primary-navigation__list li');

    menuItems.forEach(function (item) {

      item.addEventListener('mouseenter', function () {
        item.classList.toggle('active')

      });
      item.addEventListener('mouseleave', function () {
        item.classList.toggle('active')
      });
    })

    // Change arrow button being able to be tabbed to on mobile.

    const topNavButtonArrows = document.querySelectorAll('.o-primary-navigation__show-sub-menu');



    enquire.register('screen and (max-width:992px)', {
      match: function () {

        topNavButtonArrows.forEach(function (buttonArrow) {
          buttonArrow.setAttribute('tabindex', '0');
        })



      },
      unmatch: function () {
        topNavButtonArrows.forEach(function (buttonArrow) {
          buttonArrow.setAttribute('tabindex', '-1');
        })
        // Primary navigation hover drop down state



      },
    });

  },



  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js